export default __webpack_public_path__ + "static/char-thumb-37-58c26fe7693e5b7cbb2ac51064bf72fb.png";